import useSWR from 'swr'

import { apiInstance } from './apiInstance'

const fetcher = (url: string) => apiInstance.get(url).then((res) => res.data)

export const useFetchRequestlist = (sessionId: string) => {
  const { data, error } = useSWR(sessionId ? `/requestlist?session_id=${sessionId}` : null, fetcher)
  return { requestlistData: data?.data, requestlistErrorStatus: error?.response?.status }
}